//import svgPaths from './svgs';
import { /*Library, Link,*/ FileText, BookOpen } from 'lucide-react';
import Headset from './Headset';
import React from 'react';

interface MobileNavigationDrawerProps {
  onNavigate?: (page: string) => void;
}

function Frame633597({ onNavigate }: { onNavigate?: (page: string) => void }): React.JSX.Element {
  return (
    <div 
      className="h-[48px] relative rounded-[12px] shrink-0 w-full hover:bg-[rgba(0,0,0,0.05)] transition-colors cursor-pointer"
      onClick={() => onNavigate?.('case-library')}
    >
      <div className="flex flex-row items-center size-full">
        <div className="box-border content-stretch flex gap-[12px] h-[48px] items-center px-[12px] py-[8px] relative w-full cursor-pointer hover:bg-button-hover active:bg-button-active rounded-[var(--radius-card)] transition-colors">
          <div className="relative shrink-0 size-[20px]" data-name="Case Log Library Opt1">
            <BookOpen className="size-5" style={{ color: 'var(--high-emphasis-font)' }} />
          </div>
          <div className="content-stretch cursor-pointer flex flex-col gap-[5px] h-[24px] items-start justify-center relative shrink-0" data-name="Component 13">
            <div className="flex flex-col font-['Cabin:Regular',sans-serif] justify-center leading-[0] not-italic relative shrink-0 text-[18px] text-center text-nowrap" style={{ color: 'var(--high-emphasis-font)' }}>
              <p className="leading-[normal] whitespace-pre">Case Library</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Frame633593({ onNavigate }: { onNavigate?: (page: string) => void })
: React.JSX.Element {
  return (
    <div className="content-stretch flex flex-col items-start relative shrink-0 w-full">
      <Frame633597 onNavigate={onNavigate} />
    </div>
  );
}

function Frame633589({ onNavigate }: { onNavigate?: (page: string) => void })
: React.JSX.Element {
  return (
    <div className="content-stretch flex flex-col gap-[408px] items-start relative shrink-0 w-full">
      <Frame633593 onNavigate={onNavigate} />
    </div>
  );
}

function Frame633599({ onNavigate }: { onNavigate?: (page: string) => void })
: React.JSX.Element {
  return (
    <div 
      className="h-[48px] box-border content-stretch flex gap-[12px] items-center px-0 relative shrink-0 w-full hover:bg-button-hover active:bg-button-active transition-colors cursor-pointer rounded-[var(--radius-card)] px-[12px] py-[8px]"
      onClick={() => onNavigate?.('contact-us')}
    >
      <div className="overflow-clip relative shrink-0 size-[20px]" data-name="Headset">
        <Headset />
      </div>
      <div className="content-stretch cursor-pointer flex flex-col gap-[5px] h-[24px] items-start justify-center relative shrink-0" data-name="Component 13">
        <div className="flex flex-col font-['Cabin:Regular',sans-serif] justify-center leading-[0] not-italic relative shrink-0 text-[18px] text-center text-nowrap" style={{ color: 'var(--high-emphasis-font)' }}>
          <p className="leading-[normal] whitespace-pre">Contact Us</p>
        </div>
      </div>
    </div>
  );
}

function Frame633594({ onNavigate }: { onNavigate?: (page: string) => void })
: React.JSX.Element {
  return (
    <div className="content-stretch flex flex-col items-start relative shrink-0 w-full">
      <Frame633599 onNavigate={onNavigate} />
    </div>
  );
}

function Frame633601({ onNavigate }: { onNavigate?: (page: string) => void })
: React.JSX.Element {
  return (
    <div 
      className="h-[48px] box-border content-stretch flex gap-[12px] items-center px-0 relative shrink-0 w-full hover:bg-button-hover active:bg-button-active transition-colors cursor-pointer rounded-[var(--radius-card)] px-[12px] py-[8px]"
      onClick={() => onNavigate?.('terms-and-conditions')}
    >
      <div className="relative shrink-0 size-[20px]" data-name="">
        <FileText className="size-5" style={{ color: 'var(--high-emphasis-font)' }} />
      </div>
      <div className="content-stretch cursor-pointer flex flex-col gap-[5px] h-[24px] items-start justify-center relative shrink-0" data-name="Component 13">
        <div className="flex flex-col font-['Cabin:Regular',sans-serif] justify-center leading-[0] not-italic relative shrink-0 text-[18px] text-center text-nowrap" style={{ color: 'var(--high-emphasis-font)' }}>
          <p className="leading-[normal] whitespace-pre">{'Terms & Conditions'}</p>
        </div>
      </div>
    </div>
  );
}

function Frame633595({ onNavigate }: { onNavigate?: (page: string) => void })
: React.JSX.Element {
  return (
    <div className="content-stretch flex flex-col items-start relative shrink-0 w-full">
      <Frame633601 onNavigate={onNavigate} />
    </div>
  );
}

function Content(): React.JSX.Element {
  return (
    <div className="box-border content-stretch flex gap-[8px] h-[52px] items-center justify-center px-[20px] py-0 relative rounded-[12px] shrink-0" data-name="Content">
      <div className="flex flex-col font-['Cabin:SemiBold',sans-serif] justify-center leading-[0] not-italic relative shrink-0 text-[18px] text-center text-nowrap" style={{ color: 'var(--high-emphasis-font)' }}>
        <p className="leading-[normal] whitespace-pre">Sign Out</p>
      </div>
    </div>
  );
}

function Frame633592(): React.JSX.Element {
  return (
    <div className="content-stretch flex flex-col gap-[10px] items-start relative shrink-0 w-full">
      <div className="bg-white content-stretch flex items-center justify-center relative rounded-[12px] shrink-0 w-full cursor-pointer hover:bg-[rgba(0,0,0,0.02)] transition-colors" data-name="Mobile Large Primary Button">
        <div aria-hidden="true" className="absolute border-[#bdbdbd] border-[1.5px] border-solid inset-0 pointer-events-none rounded-[12px]" />
        <Content />
      </div>
    </div>
  );
}

function Frame633596({ onNavigate }: { onNavigate?: (page: string) => void }): React.JSX.Element {
  return (
    <div className="content-stretch flex flex-col gap-[24px] items-start relative shrink-0 w-full">
      <Frame633594 onNavigate={onNavigate} />
      <Frame633595 onNavigate={onNavigate} />
      <div className="h-0 relative shrink-0 w-full">
        <div className="absolute bottom-[-1px] left-0 right-0 top-[-1px]" style={{ '--stroke-0': 'rgba(238, 238, 238, 1)' } as React.CSSProperties}>
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 359 2">
            <path d="M0_1H359" id="Vector 1710" stroke="var(--stroke-0, #EEEEEE)" strokeWidth="2" />
          </svg>
        </div>
      </div>
      <Frame633592 />
    </div>
  );
}

export default function MobileNavigationDrawer440Bp({ onNavigate }: MobileNavigationDrawerProps): React.JSX.Element {
  return (
    <div className="bg-[#fcfcfc] relative size-full" data-name="Mobile Navigation Drawer 440bp">
      <div className="size-full">
        <div className="box-border content-stretch flex flex-col items-start justify-between pb-[16px] pt-[24px] px-[16px] relative size-full">
          <Frame633589 onNavigate={onNavigate} />
          <Frame633596 onNavigate={onNavigate} />
        </div>
      </div>
    </div>
  );
}
